

    <form [formGroup]="vorderingenOfContantGeld">
        <div class="row">
            <ng-container formArrayName="box3VorderingenOfContantGeld">
                <ng-container
                        *ngFor="let item of box3VorderingenOfContantGeld.controls; let i = index; "
                        [formGroupName]="i">
                    <div>
                        <snelstart-ui-text-form-control formControlName="omschrijving"
                                                        id="omschrijving"
                                                        [label]="i === 0 ? 'Omschrijving vordering / contant geld' : ''"
                                                        class="custom-input-250"
                                                        (change)="saveForm()"
                        >
                        </snelstart-ui-text-form-control>
                        <snelstart-ui-number-form-control formControlName="bedrag"
                                                          id="bedrag"
                                                          [label]="i === 0 ? 'Waarde 1-1' : ''"
                                                          class="custom-input-150"
                                                          [decimals]="0"
                                                          [minValue]="0"
                                                          align="right"
                                                          prefix="€"
                                                          (change)="saveForm()"

                        >
                        </snelstart-ui-number-form-control>
                        <snelstart-ui-button id="buttonDeleteKosten"
                                                    type="secondary"
                                                    size="medium"
                                                    iconType="light"
                                                    (click)="verwijderRijVorderingenOfContantGeld(i)"
                                                    [class]="i === 0 ? 'firstrowbutton' : ''"
                        >
                        </snelstart-ui-button>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </form>

    <div *ngIf="box3VorderingenOfContantGeld.length === 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijVorderingenOfContantGeld()">Vordering/contant geld invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="box3VorderingenOfContantGeld.length > 0">
        <snelstart-ui-button class="snelstart-ui-button pb-3" type="link" icon="plus"
                             (click)="addRijVorderingenOfContantGeld()">Vordering/contant geld toevoegen
        </snelstart-ui-button>
    </div>



